import * as Yup from 'yup';

import { verification } from '../common/attributes';

const learnerAndAccountRegistrationVerificationFormSchema = () => {
  return Yup.object().shape({
    verification: verification('verification_code'),
  });
};

export default learnerAndAccountRegistrationVerificationFormSchema;
